"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessLoggerSymbol = void 0;
exports.BusinessLoggerSymbol = Symbol('BusinessLogger');
//# sourceMappingURL=businessLogger.js.map